import useAuth from 'hooks/use-auth'
import { useFeatureFlags } from 'hooks/use-feature-flags'
import {
  attacksCompletedPagedGet,
  failureFlagsExperimentsCompletedGet,
  reliabilityTestsCompletedPagedGet,
  scenariosCompletedPagedGet
} from 'utils/endpoints-access'

export function useWhatRanAccess() {
  const {
    currentTeamId,
    hasEndpointAccess,
    hasFailureFlags,
    hasFaultInjection,
    hasReliabilityManagement
  } = useAuth()

  const { nowRunning: isNowRunningEnabled } = useFeatureFlags()

  const accessOptions = { teamId: currentTeamId }

  const canShowAttacksSection =
    isNowRunningEnabled &&
    hasFaultInjection &&
    hasEndpointAccess(attacksCompletedPagedGet, accessOptions)
  const canShowFailureFlagsSection =
    isNowRunningEnabled &&
    hasFailureFlags &&
    hasEndpointAccess(failureFlagsExperimentsCompletedGet, accessOptions)
  const canShowScenariosSection =
    isNowRunningEnabled &&
    hasFaultInjection &&
    hasEndpointAccess(scenariosCompletedPagedGet, accessOptions)
  const canShowServiceSection =
    isNowRunningEnabled &&
    hasReliabilityManagement &&
    hasEndpointAccess(reliabilityTestsCompletedPagedGet, accessOptions)

  return {
    attacks: canShowAttacksSection,
    failureFlags: canShowFailureFlagsSection,
    scenarios: canShowScenariosSection,
    services: canShowServiceSection,
    section:
      canShowAttacksSection ||
      canShowFailureFlagsSection ||
      canShowServiceSection ||
      canShowScenariosSection
  }
}
